import UniformBodyContent from "./components/body-content/src";
import UniformButton from "./components/button/src";
import UniformCard from "./components/card";
import {
    UniformColumnLayout,
    UniformSubColumnLayout
} from "./components/column-layout";
import UniformContainer from "./components/container";
import UniformContentBlock from "./components/content-block/src";
import UniformCtaWithPolygonBackground from "./components/cta-with-polygon-background-section/src";
import UniformCustomerStats from "./components/customer-stats";
import UniformCustomerStoriesDetailsHero from "./components/customer-stories-details-hero/src";
import UniformCustomerTestimonials from "./components/customer-testimonials";
import UniformGlobalFooter from "./components/global-footer";
import UniformGlobalNav from "./components/global-nav";
import UniformHeading from "./components/heading";
import UniformHeroSection from "./components/hero/src";
import UniformHeroIntro from "./components/hero-intro/src";
import UniformHorizontalDivider from "./components/horizontal-divider/src";
import UniformImage from "./components/image/src";
import { UniformJiraTemplatesTabContentSubgridLayout } from "./components/jira-templates-tab-content-subgrid-layout";
import UniformLink from "./components/link/src";
import UniformList from "./components/list";
import UniformListV2 from "./components/listv2";
import UniformModal from "./components/modal";
import UniformPage from "./components/page";
import UniformProductCard from "./components/product-card/src";
import UniformPullQuote from "./components/pull-quote";
import UniformSplitColorBackgroundContainer from "./components/split-color-background-container/index";
import { UniformFullWidthTabs, UniformSmallTabs } from "./components/tabs";
import UniformTemplateModalButton from "./components/template-modal-button/src";
import UniformTemplatePreview from "./components/template-preview/src";
import UniformText from "./components/text/src";
import UniformTextWithIcon from "./components/text-with-icon/src";
import UniformVariantContainer from "./components/variant-container";
import UniformStatsSection from "./patterns/stats-section/src";

// TODO: Fix types
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const UNIFORM_DEFINITIONS: Record<string, any> = {
    // add these in alphabetical order
    blockContainer: UniformContainer,
    button: UniformButton,
    card: UniformCard,
    columnLayout: UniformColumnLayout,
    contentBlock: UniformContentBlock,
    ctaWithPolygonBackground: UniformCtaWithPolygonBackground,
    customerBodyContent: UniformBodyContent,
    customerStat: UniformCustomerStats,
    customerStoriesDetailsHero: UniformCustomerStoriesDetailsHero,
    customerTestimonials: UniformCustomerTestimonials,
    fullWidthTabs: UniformFullWidthTabs,
    globalFooter: UniformGlobalFooter,
    globalNav: UniformGlobalNav,
    heading: UniformHeading,
    heroIntro: UniformHeroIntro,
    heroSection: UniformHeroSection,
    horizontalDivider: UniformHorizontalDivider,
    image: UniformImage,
    jiraTemplatesTabContentSubgridLayout:
        UniformJiraTemplatesTabContentSubgridLayout,
    link: UniformLink,
    list: UniformList,
    listv2: UniformListV2,
    modal: UniformModal,
    page: UniformPage,
    productCard: UniformProductCard,
    pullQuote: UniformPullQuote,
    smallTabs: UniformSmallTabs,
    splitBackgroundContainer: UniformSplitColorBackgroundContainer,
    statsSection: UniformStatsSection,
    subColumnLayout: UniformSubColumnLayout,
    templateModalButton: UniformTemplateModalButton,
    templatePreview: UniformTemplatePreview,
    text: UniformText,
    textWithIcon: UniformTextWithIcon,
    variantContainer: UniformVariantContainer
};

export default UNIFORM_DEFINITIONS;
